import {Component, inject} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {RouterLink} from '@angular/router'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {Helper} from '../../services/helper'
import {MatDialog} from '@angular/material/dialog'
import {RenewCertComponent} from '../renew-cert/renew-cert.component'
import {DockerAuthComponent} from '../../gitlab/docker-auth/docker-auth.component'


@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    MatIconButton,
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    LogoComponent,
    RouterLink,
    ToggleButtonComponent
  ]
})
export class HeaderComponent {
  public readonly service = inject(ConfigService)
  public readonly helper = inject(Helper)

  private readonly dialog = inject(MatDialog)

  public certs() {
    this.dialog.open(RenewCertComponent)
  }

  public confs() {
    this.dialog.open(DockerAuthComponent)
  }
}
